import $ from 'jquery';
import EFOcats_settingdata from '../../../core/v2/setting/efocats_settingdata.js';

export default class EFOcats_iwatani_settingdata extends EFOcats_settingdata {
  /**
   * 入力欄をページごとに振り分ける
   * @param {*} form
   * @returns ページリスト
   */
  get_pages(form) {
    const pages = [];
    const titles = $(form).find('#buy tr');

    for (let index = 0; index < titles.length - 1; index++) {
      if (titles.eq(index).find('[name="email"]').length > 0) {
        pages.push(`${titles.eq(index).prop('outerHTML')}${titles.eq(index + 1).prop('outerHTML')}`);
        index += 1;
      } else if (titles.eq(index).find('[name="password"]').length > 0) {
        pages.push(
          `<tr><th>パスワード<span class="required">[必須]</span></th><th>パスワード（確認）<span class="required">[必須]</span></th><td>${titles
            .eq(index)
            .find('.password')
            .prop('outerHTML')}</td></tr>`
        );
        pages.push(
          `<tr><th>質問<span class="required">[必須]</span></th><th>回答<span class="required">[必須]</span></th><td>${titles
            .eq(index)
            .find('.reminder')
            .prop('outerHTML')}</td></tr>`
        );
      } else if (titles.eq(index).find('[name="zip01"]').length > 0) {
        pages.push(titles.eq(index).prop('outerHTML'));
        index += 1;
      } else {
        pages.push(titles.eq(index).prop('outerHTML'));
      }
    }

    pages.push($(form).find('input[name="chk01"]').parents('tr').prop('outerHTML'));
    pages.push($(form).find('#agree label').eq(0).prop('outerHTML'));

    return pages;
  }

  /**
   * 設問テキストを取得する
   * @param {*} page
   * @returns 設問テキスト
   */
  get_text(page) {
    if ($(page).find('th').length === 1) {
      return $(page).find('th').text().replace('[必須]', '').trim();
    }

    const list = [];

    for (let index = 0; index < $(page).find('th').length; index++) {
      const element = $(page).find('th').eq(index);
      list.push(element.text().replace('[必須]', '').trim());
    }

    return list;
  }

  /**
   * 必須かどうかを取得する
   * @param {*} page
   * @returns 必須なら1、そうでないなら0
   */
  get_required(page) {
    if ($(page).find('th').find('.required').length > 0) {
      return 1;
    }

    return 0;
  }

  /**
   * ページ内の入力欄を一通り取得する
   * @param {*} page
   * @returns 入力欄リスト
   */
  get_inputs(page) {
    const inputs = [];

    const list = $(page).find('input,select,textarea');

    for (let index = 0; index < list.length; index++) {
      if ($(list[index]).attr('name') !== 'tel02' && $(list[index]).attr('name') !== 'tel03') {
        inputs.push(list[index]);
      }
    }

    return inputs;
  }

  /**
   * JSONデータを編集する
   * @param data 読み込んだデータ
   * @param formQuery 元フォームを取得するためのクエリ
   * @returns 編集したデータ
   */
  edit(data, formQuery) {
    data.form.label = [];

    // 選択ページを最初に挿入
    const tempChoice = {
      question: '注文内容確認',
    };

    const choiceOBj = {};
    choiceOBj['set-base'] = tempChoice;

    data.form.label.push(choiceOBj);

    // 指定したIDのフォームを取得
    const form = document.querySelector(formQuery);

    if (this.check(form)) {
      let pages = this.get_pages(form);

      for (let index = 0; index < this.patterns.length; index++) {
        const pattern = this.patterns[index];
        pages = pattern.get_pages(form, pages);
      }

      // ページ単位で処理
      pages.forEach(page => {
        const temp = {
          question: this.get_text(page),
          answer: [],
        };

        let tpl = this.get_tpl(page);

        for (let index = 0; index < this.patterns.length; index++) {
          const pattern = this.patterns[index];
          tpl = pattern.get_tpl(page, tpl);
        }

        let inputs = this.get_inputs(page);

        for (let index = 0; index < this.patterns.length; index++) {
          const pattern = this.patterns[index];
          inputs = pattern.get_inputs(page, inputs);
        }

        if (inputs.length === 0) {
          return;
        }

        if (inputs[0].type === 'radio' || inputs[0].type === 'checkbox') {
          // radio、チェックボックスの場合
          this.get_radio_checkbox(page, inputs, temp);
        } else {
          // radio、チェックボックスの以外場合
          this.get_radio_checkbox_other(page, inputs, temp);
        }

        // フリーテキスト
        this.get_free_text(page, temp);

        for (let index = 0; index < this.patterns.length; index++) {
          const pattern = this.patterns[index];
          pattern.pagedata_extend(page, temp);
        }

        const lastOBj = {};
        lastOBj[tpl] = temp;

        data.form.label.push(lastOBj);
      });
    }

    // 選択ページを最初に挿入
    const tempPayment = {
      question: '支払方法説明',
    };

    const paymentOBj = {};
    paymentOBj['set-base'] = tempPayment;

    data.form.label.splice(9, 0, paymentOBj);

    return data;
  }

  /**
   * テンプレート名を取得する
   * @param {*} page
   * @returns テンプレート名
   */
  get_tpl(page) {
    if ($(page).find('[name="zip01"]').length > 0) {
      return 'set-adress';
    }

    if ($(page).find('[name="year"]').length > 0) {
      return 'set-birthday';
    }

    return 'set-base';
  }

  /**
   * 属性を取得する
   * @param {*} page
   * @param {*} inputs
   * @param {*} index
   * @param {*} tempanswer
   */
  get_attr(page, inputs, index, tempanswer) {
    super.get_attr(page, inputs, index, tempanswer);

    if ($(page).find('[name="email"]').length > 0 || $(page).find('[name="password"]').length > 0 || $(page).find('[name="reminder"]').length > 0) {
      tempanswer.line = index;
    }
  }

  /**
   * ラジオボタンとチェックボックスを取得する
   * @param {*} input
   * @param {*} temp
   */
  get_radio_checkbox(page, input, temp) {
    const valueList = {};
    const nameList = [];
    const typeList = {};

    for (let k = 0, l = input.length; k < l; k++) {
      // valueをname別に収集
      if (!valueList[input[k].name]) {
        valueList[input[k].name] = [];
      }

      const tempval = {};

      if (input[k].name === 'chk01' || input[k].name === 'agree[]') {
        tempval[input[k].value] = '同意する';
      } else {
        tempval[input[k].value] = input[k].parentNode.textContent;
      }

      tempval[input[k].value] = tempval[input[k].value].replace('可', 'はい').replace('否', 'いいえ');

      valueList[input[k].name].push(tempval);

      // nameを収集
      if (nameList.indexOf(input[k].name) === -1) nameList.push(input[k].name);

      // typeもnameに合わせる
      typeList[input[k].name] = input[k].type;
    }

    for (let k = 0, l = nameList.length; k < l; k++) {
      const tempanswer = {
        type: typeList[nameList[k]] || input[0].type,
        name: nameList[k],
        'data-required': String(this.get_required(page)),
        value: valueList[nameList[k]] || [],
      };

      // 属性設定
      this.get_attr(page, input, k, tempanswer);

      temp.answer.push(JSON.parse(JSON.stringify(tempanswer)));
    }
  }
}
